import { TableTheme as DefaultTableTheme } from "@acin.reactjs/acin-ui/table";
import { applyIconColor } from "@acin.reactjs/acin-ui/theme";
import { DefaultTheme } from "styled-components";
import { AppMediaQueries } from "./BreakpointsTheme";

const TableTheme = (theme: DefaultTheme): DefaultTableTheme => ({
  disposition: {
    footer: {
      display: "flex",
      alignItems: "center",
      marginTop: "10px",
    },

    separator: {
      flexGrow: 1,
    },

    separatorPageSize: {
      marginRight: "12px",
    },
  },

  resultsCount: {
    display: "block",
    fontSize: "14px",
  },

  pageSizes: {
    inputContainer: {
      [AppMediaQueries.maxTablet]: {
        height: "24px",
        minHeight: "24px",
        padding: "4px 8px",
        paddingBlock: "4px",
      },
    },
    input: {
      [AppMediaQueries.maxTablet]: {
        fontSize: "14px",
        lineHeight: "18px",
      },
    },
  },

  body: {
    row: {
      root: {
        height: "30px",
      },

      hover: {
        background: theme.palette.primary[50],
      },

      selected: {
        "&:hover": {
          backgroundColor: "unset",
        },
      },
    },
    cols: {
      actions: {
        root: {
          paddingLeft: "10px",
        },
      },
      actionGroup: {
        dropdown: {
          minWidth: "70px !important",

          "ul li": {
            padding: "8px 16px",
            height: "32px",

            "& > div": {
              marginRight: "0px",
            },

            "& span": {
              fontSize: "14px",
            },

            '&[title="Eliminar"], &[title="Delete"]': {
              color: "#87200E",
              borderTop: `1px solid ${theme.palette.greys[100]}`,

              "&:hover": {
                backgroundColor: `${theme.palette.status.error[50]} !important`,
              },
            },
          },
        },
      },
    },
  },

  cols: {
    actions: {
      minWidth: "80px",
    },
  },

  header: {
    root: {
      borderBottom: `2px solid ${theme.palette.primary[700]}`,
    },
    cols: {
      root: {
        padding: "0px 5px 5px 5px",
      },
      actions: {
        svg: applyIconColor(theme.palette.primary[700]),
      },
    },
  },
});

export default TableTheme;
